import React, { useState, useEffect, useRef } from "react"
import Modal from "react-bootstrap/Modal"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Row from "react-bootstrap/esm/Row"
import Col from "react-bootstrap/esm/Col"
import SurveyComponent from "../../../../pages/RMO/components/cancerTemplate/Template"
import defaultSurveyConfig from "../../../../pages/RMO/components/cancerTemplateForm/template"
import "./forms.scss"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { useSelector } from "react-redux"
import { Typography } from "@mui/material"
import {
  getListCancerTemplateConsents,
  getAppointmentById,
  getConsentForms,
  saveConsentForm,
  updateAppointment,
  updateConsentForm, getSmartSummaryData,
  sendClinicalPdfData, getFormsAndTemplates, getConsentFormsById
} from "../../../../core/services/api"
import { MocUserRole } from "../../../../core/services/models/Enums"
import {
  faFileAlt,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "../../../Button"
import Toast from "../../../Toast"
import { getMandatoryForms } from "core/services/api/mrdService"
import Select from "react-select"
import { generateClinicalSummary, getConsentTemplate } from "core/services/api/patientDiagnosisService"
import { useHistory } from "react-router"
import moment from "moment"
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader"
import CommonPrintComponent from "components/CommonPrintComponent/CommonPrintComponent"
import fileUtils from "fileUtils"
import { calculateAge } from "core/utils/date"
import Print from "components/Print/Print"

function Forms({ closePrintModal, patientInfo, appointmentId, show, setShow, chosenForm, appointment, staffInfo }: any) {

  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const component = useSelector((state: any) => state.drawer?.componentData)
  const componentRef = useRef(null)
  const history = useHistory()
  const pathName = history?.location?.pathname
  //Form selection state values
  const [formSelected, setFormSelected] = useState<any>()
  const [savedFormSelected, setSavedFormSelected] = useState<any>()
  const [completedFormSelected, setCompletedFormSelected] = useState<any>()
  //Data Obj for Form
  const [consentJSON, setConsentJSON] = useState<any>({})
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [savedConsentJSON, setSavedConsentJSON] = useState<any>({})
  const [comletedConsentJSON, setComletedConsentJSON] = useState<any>({})
  const [comletedConsentPrintJSON, setComletedConsentPrintJSON] = useState<any>({})
  //Tab index
  const [value, setValue] = React.useState(userRole === MocUserRole?.MRD && pathName === "/patientList" ? 2 : 0)
  //Master form options
  const [actualFormOptions, setActualFormOptions] = useState([])
  const [actaulSavedFormOptions, setActualSavedFormOptions] = useState<any>([])
  const [actaulCompletedFormOptions, setActualCompletedFormOptions] = useState<any>([])
  //Formatted form options
  const [formOptions, setFormOptions] = useState([])
  const [savedFormOptions, setSavedFormOptions] = useState<any>([])
  const [completedFormOptions, setCompletedFormOptions] = useState<any>([])
  //Appointment Details
  const [appointmentDetails, setAppointmentDetails] = useState<any>()
  //My docs tab panel data
  const [mrdDocs, setMrdDocs] = useState([])
  //Saved and Completed Forms Master Data
  const [forms, setForms] = useState([])
  const [savedForms, setSavedForms] = useState([])
  const [completedForms, setCompletedForms] = useState([])
  const [surveyData, setSurveyData] = useState<any>()
  //MRD Mandated checklist
  const [checklistItems, setChecklistItems] = useState<any>([])
  //Toast state
  const [isApproved, setIsApproved] = useState<boolean>(false)
  const [isRejected, setIsRejected] = useState<boolean>(false)
  const [saved, setSaved] = useState<boolean>(false)
  const [isAllVerified, setIsAllVerified] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<any>(false)
  const [isError, setIsError] = useState<boolean>(false)
  //Default signature
  const [staffDetails, setStaffDetails] = useState<any>()
  //Smart Sumamary
  const [smartSummaryData, setSmartSummaryData] = useState<any>()

  const [formNumber, setFormNumber] = useState<any>("")
  const [displayToast, setDisplayToast] = useState<any>(null);

  useEffect(() => {
    if (staffInfo) {
      setStaffDetails(staffInfo)
      const temp = { ...surveyData }
      if (!Object.keys(temp)?.includes("consultantSignature")) {
        temp["consultantSignature"] = staffInfo?.signaturePicUrl
      }
      if (!Object.keys(temp)?.includes("evaluatingConsultantSignature")) {
        temp["evaluatingConsultantSignature"] = staffInfo?.signaturePicUrl
      }
      if (!Object.keys(temp)?.includes("consultantName")) {
        temp["consultantName"] = staffInfo?.name
      }
      setSurveyData({ ...temp })
    }
  }, [staffInfo])

  useEffect(() => {
    if (patientInfo?.id) {
      getSmartSummaryData(patientInfo?.id)
        .then((res: any) => {
          setSmartSummaryData(res?.data)
        }).catch((err: any) => {
          console.log(err?.message)
        })
    }
  }, [])

  useEffect(() => {
    if (chosenForm) {
      // setIsLoading(true)
      getFormsAndTemplates()
        .then((res: any) => {
          setIsLoading(false)
          const found = res?.find((each: any) => each?.subType === chosenForm)
          if (found) {
            setFormSelected({ label: found?.subType, value: found?.id })
          }
        })
        .catch((err: any) => {
          setIsLoading(false)
          console.log("Err", err)
        })
    }
  }, [chosenForm])

  useEffect(() => {
    if (appointmentId) {
      getAppointmentById(appointmentId)
        .then((res: any) => {
          setAppointmentDetails(res)
          if (userRole === MocUserRole?.MRD && pathName === "/patientList") {
            setMrdDocs(res?.documents)
          }
          else {
            setMrdDocs(res?.mrdDocuments)
          }
        })
        .catch((err: any) => {
          console.log(err?.message)
        })
    }
  }, [appointmentId])

  useEffect(() => {
    if (appointmentId) {
      getMandatoryForms(appointmentId)
        .then((res: any) => {
          const mandatedForms: any = []
          if (res?.length > 0) {
            res?.forEach((each: any) => mandatedForms.push(each?.subType))
          }
          setChecklistItems(mandatedForms)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [appointmentId])

  useEffect(() => {
    if (appointmentId) {
      getFormOptions()
      if (value === 0) {
        getForms()
      }
      if (value === 1) {
        getSavedForms()
      }
      if (value === 2) {
        getCompletedForms()
      }
    }
  }, [value, appointmentId])

  useEffect(() => {

    const setValueForElement = (element: any, temp: any) => {
      if (Object?.keys(element)?.includes("elements")) {
        element?.elements?.forEach((ele: any) => {
          setValueForElement(ele, temp)
        })
      } else if (Object?.keys(element)?.includes("templateElements")) {
        const parentNodeName = element?.name
        if (!temp[parentNodeName]) {
          temp[parentNodeName] = {}
        }

        element?.templateElements?.forEach((ele: any) => {
          setValueForElement(ele, temp[parentNodeName])
        })
      } else {
        const nodeName = element?.name;

        switch (nodeName) {
          case "consultantName":
            temp[`${nodeName}`] = staffDetails?.name;
            break;

          case "consultantSignature":
          case "dieticianSignature":
            temp[`${nodeName}`] = staffDetails?.signaturePicUrl;
            break;

          case "primaryConsultantName":
            temp[`${nodeName}`] = staffInfo?.name;
            break;

          case "primaryConsultantSignature":
            temp[`${nodeName}`] = staffInfo?.signaturePicUrl;
            break;

          case "evaluatingConsultantSignature":
            temp["evaluatingConsultantSignature"] = staffDetails?.signaturePicUrl;
            break;

          case "patientName":
          case "nameOfPatient":
          case "pName":
            temp[`${nodeName}`] = patientInfo?.isVIP ? patientInfo?.mocId : patientInfo?.name;
            break;

          case "patientId":
          case "UHID":
          case "uhid":
            temp[`${nodeName}`] = patientInfo?.mocId;
            break;

          case "patientDob":
            temp["patientDob"] = patientInfo?.dob;
            break;

          case "patientAgeGender":
          case "ageGender":
            temp[`${nodeName}`] = `${calculateAge(patientInfo?.dob)}/${patientInfo?.gender}`;
            break;

          case "patientAge":
          case "age":
            temp[`${nodeName}`] = calculateAge(patientInfo?.dob);
            break;

          case "patientGender":
          case "gender":
          case "sex":
            temp[`${nodeName}`] = patientInfo?.gender;
            break;

          case "patientAddress":
          case "Address":
            temp[`${nodeName}`] = patientInfo?.addressInfo ?
              `${patientInfo?.addressInfo?.addressLine1 ? patientInfo?.addressInfo?.addressLine1 + ", " : ""}${patientInfo?.addressInfo?.addressLine2 ? patientInfo?.addressInfo?.addressLine2 + ", " : ""}${patientInfo?.addressInfo?.suburb ? patientInfo?.addressInfo?.suburb + ", " : ""}${patientInfo?.addressInfo?.district ? patientInfo?.addressInfo?.district + ", " : ""}${patientInfo?.addressInfo?.state ? patientInfo?.addressInfo?.state + ", " : ""}${patientInfo?.addressInfo?.country ? patientInfo?.addressInfo?.country + ", " : ""}${patientInfo?.addressInfo?.pincode ? patientInfo?.addressInfo?.pincode : ""}`
              : "";
            break;

          case "patientMobileNo":
            temp[`${nodeName}`] = patientInfo?.phoneNumber;
            break;

          case "patientEmailId":
            temp[`${nodeName}`] = patientInfo?.email;
            break;

          case "todaysDate":
          case "consultantSignatureDate":
          case "patientSignatureDate":
          case "relativeSignatureDate":
          case "staffSignatureDate":
          case "date":
          case "nameOfRelativeOrRelationDate":
          case "consultantDate":
          case "patientDate":
          case "dateNameOfPersonProvidingInformation":
          case "admittedOnDate":
          case "dateOfApplication":
          case "witnessDate":
          case "nurseSignatureDate":
          case "dateOfAdmission":
          case "todaysDate_TPA":
            temp[`${nodeName}`] = moment().format("YYYY-MM-DD");
            break;

          case "patientTime":
          case "relativeTime":
          case "consultantSignatureTime":
          case "relativeSignatureDate":
          case "staffSignatureTime":
          case "timeOfAdmission":
          case "timeOfDischarge":
          case "hospitalStaffTime":
            temp[`${nodeName}`] = moment().format("HH:MM");
            break;

          case "currentDateTime":
          case "consultantDateTime":
          case "relativeDateTime":
          case "receiverDateTime":
          case "applicantDateTime":
            temp[`${nodeName}`] = moment().format("YYYY-MM-DDTHH:MM");
            break;

          case "diagnosis":
            let diagnosisStr = "";
            smartSummaryData?.diagnosis?.forEach((each: any) => {
              diagnosisStr += `${each?.diagnosis ? each?.diagnosis : "NA"} (${each?.cancerType ? each?.cancerType : ""}). `;
            });
            temp[`${nodeName}`] = diagnosisStr;
            break;

          case "centerName":
            temp[`${nodeName}`] = userDetail?.currentCenter?.centerName;
            break;

          case "room":
            temp[`${nodeName}`] = appointmentDetails?.allottedBed?.roomName;
            break;

          default:
            // Optional: handle the case where nodeName doesn't match any case
            break;
        }
      }
    }

    if (formSelected?.value) {
      setConsentJSON({})
      getConsentTemplate("CONSENT", formSelected?.value)
        .then((res: any) => {
          setConsentJSON(res)
          let temp: any = {}
          res?.pages?.forEach((page: any) => {
            page?.elements?.forEach((element: any) => {
              setValueForElement(element, temp)
            })
          })
          setSurveyData(temp)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [formSelected])

  useEffect(() => {
    if (savedFormSelected?.value) {
      setFormNumber("")
      setSavedConsentJSON({})
      getConsentFormsById(savedFormSelected?.value)
        .then((res: any) => {
          const json = res?.data[0]?.json
          setSavedConsentJSON(json)
          const formNo = res?.formNumber
          setFormNumber(formNo)
          const foundObj: any = savedForms?.find((ele: any) => ele.formTemplateName === savedFormSelected?.label)
          const temp = { ...foundObj?.data }
          if (!Object.keys(temp)?.includes("consultantSignature")) {
            temp["consultantSignature"] = staffDetails?.signaturePicUrl
          }
          setSurveyData(temp)
        })
    }
  }, [savedFormSelected])

  useEffect(() => {
    if (completedFormSelected?.value) {
      setFormNumber("")
      setComletedConsentJSON({})
      setComletedConsentPrintJSON({})
      getConsentFormsById(completedFormSelected?.value, appointmentId)
        .then((res: any) => {
          const json = res?.data[0]?.json
          const formNo = res?.formNumber
          setFormNumber(formNo)
          const tempJson: any = { ...json }
          const checkReadOnly: any = json?.pages[0]?.readOnly
          if (checkReadOnly) {
            if (tempJson?.pages?.length === 1) {
              tempJson["showNavigationButtons"] = "none"
              setComletedConsentJSON(tempJson)
            } else {
              setComletedConsentJSON(tempJson)
              setTimeout(() => {
                const completeBtn = document?.getElementById("sv-nav-complete")
                if (completeBtn) {
                  completeBtn.style.display = "none"
                }
              }, 2000)
            }
          } else {
            setComletedConsentJSON(tempJson)
          }
          // if (completedFormSelected?.label === "Thank you Note" || completedFormSelected?.label === "Referral Note") {
          //   if (completedFormSelected?.label === "Thank you Note") {
          //     tempJson.pages[0].elements[2].choices = referalConsultantsOptions
          //     let printJSON: any = getPrintJson(tempJson)
          //     setComletedConsentJSON(tempJson)
          //     setComletedConsentPrintJSON(printJSON)
          //   } else {
          //     tempJson.pages[0].elements[2].choices = referalConsultantsOptions
          //     let printJSON: any = getPrintJson(tempJson)
          //     setComletedConsentJSON(tempJson)
          //     setComletedConsentPrintJSON(printJSON)
          //   }
          // } else {
          let printJSON: any = getPrintJson(tempJson)
          setComletedConsentPrintJSON(printJSON)
          // }
          const foundObj: any = completedForms?.find((ele: any) => ele.formTemplateName === completedFormSelected?.label)
          const tempData = { ...foundObj?.data }
          if (!Object.keys(tempData)?.includes("consultantSignature")) {
            tempData["consultantSignature"] = staffDetails?.signaturePicUrl
          }
          setSurveyData(tempData)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }, [completedFormSelected])

  const getFormOptions = () => {
    if (appointmentId) {
      getListCancerTemplateConsents("CONSENT", appointmentId)
        .then((res: any) => {
          setActualFormOptions(res)
          const temp = res?.map((ele: any) => {
            return { label: ele?.subType, value: ele?.id, formNumber: ele?.formNumber }
          })
          setFormOptions(temp)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  const getForms = () => {
    if (appointmentId) {
      getConsentForms({
        appointmentId: appointmentId,
        type: ""
      })
        .then((res: any) => {
          setForms(res)
        })
        .catch((err: any) => console.log(err.message))
    }
  }

  const getSavedForms = () => {
    if (appointmentId) {
      getConsentForms({
        appointmentId: appointmentId,
        type: "SAVED"
      })
        .then((res: any) => {
          setSavedForms(res)
          const options: any = []
          const fullOptions: any = []
          res.forEach((each: any) => {
            options.push({ label: each?.formTemplateName, value: each?.formTemplateId })
            fullOptions.push({ id: each?.formTemplateId, subType: each?.formTemplateName })
          })
          setActualSavedFormOptions(fullOptions)
          // const temp = options.map((each: any) => {
          //   return { label: each, value: each }
          // })
          setSavedFormOptions(options)
        })
        .catch((err: any) => console.log(err.message))
    }
  }

  const getCompletedForms = () => {
    if (appointmentId) {
      getConsentForms({
        appointmentId: appointmentId,
        type: "COMPLETED"
      })
        .then((res: any) => {
          const tempCompleted = res?.map((ele: any) => {
            return { ...ele, verified: false }
          })
          setCompletedForms(tempCompleted)
          const options: any = []
          const fullOptions: any = []
          res.forEach((each: any) => {
            options.push({ label: each?.formTemplateName, value: each?.formTemplateId, formNumber: each?.formNumber })
            fullOptions.push({ id: each?.formTemplateId, subType: each?.formTemplateName, formNumber: each?.formNumber })
          })
          setActualCompletedFormOptions(fullOptions)
          // const temp = options.map((each: any) => {
          //   return { label: each, value: each }
          // })
          setCompletedFormOptions(options)
        })
        .catch((err: any) => console.log(err.message))
    }
  }

  const handleClose = () => {
    setShow(false)
    closePrintModal(false)

  }

  const handleFormComplete = (dataObj: any, type: string) => {
    let formObj: any
    if (type === "form") {
      formObj = actualFormOptions?.find((form: any) => form?.subType === formSelected?.label)
    } else if (type === "saved") {
      formObj = actaulSavedFormOptions?.find((form: any) => form?.subType === savedFormSelected?.label)
    } else if (type === "completed") {
      formObj = actaulCompletedFormOptions?.find((form: any) => form?.subType === completedFormSelected?.label)
    }
    const payload = {
      "centerId": appointmentDetails?.centerId,
      "patientId": appointmentDetails?.patientId,
      "appointmentId": appointmentId,
      "formTemplateId": formObj?.id,
      "data": dataObj,
    }
    if (type === "form") {
      saveConsentForm(payload)
        .then((res: any) => {
          getFormOptions()
          getForms()
          setSaved(true)
          //Save response data based on type
          setSurveyData(res?.data)
          setFormSelected("")
          setConsentJSON({})
        }).catch((err: any) => {
          console.error("Error saving consent form:", err);
          setDisplayToast({
            text: `${err?.response?.data?.message || "Failed to save form"}`,
            type: "error",
          });
        });
    } else if (type === "saved" || type === "completed") {
      let temp: any
      if (type === "saved") {
        temp = savedForms?.find((form: any) => form?.formTemplateName === savedFormSelected?.label)
      } else {
        temp = completedForms?.find((form: any) => form?.formTemplateName === completedFormSelected?.label)
      }
      updateConsentForm(payload, temp?.id)
        .then((res: any) => {
          setSaved(true)
          if (type === "saved") {
            getSavedForms()
            setSurveyData(res?.data)
            const temp: any = savedForms?.map((ele: any) => {
              if (ele?.id === res?.id) {
                return { ...ele, ...res }
              } else {
                return { ...ele }
              }
            })
            setSavedFormSelected("")
            setSavedConsentJSON({})
            setSavedForms(temp)
          } else if (type === "completed") {
            getCompletedForms()
            setSurveyData(res?.data)
            const temp: any = completedForms?.map((ele: any) => {
              if (ele?.id === res?.id) {
                return { ...ele, ...res }
              } else {
                return { ...ele }
              }
            })
            setCompletedFormSelected("")
            setComletedConsentJSON({})
            setComletedConsentPrintJSON({})
            setCompletedForms(temp)
          }
        })
        .catch((err) => {
          console.error("Error updating consent form:", err);
          setDisplayToast({
            text: `${err?.response?.data?.message || "Failed to update form"}`,
            type: "error",
          });
        });

    }
  }
  interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        className="form-wrapper"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    }
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setFormSelected("")
    setConsentJSON({})
    setSavedFormSelected("")
    setSavedConsentJSON({})
    setCompletedFormSelected("")
    setComletedConsentJSON({})
    setComletedConsentPrintJSON({})
    setFormNumber("")
    setValue(newValue)
  }

  const handleCompletenessChange = (type: boolean) => {
    if (type) {
      const verified = completedForms.every((each: any) => each?.verified === true)
      if (verified) {
        handleApprovalRejection("APPROVED")
      } else {
        setIsAllVerified(true)
      }
    } else {
      handleApprovalRejection("REJECTED")
    }
  }

  const handleApprovalRejection = (type: string) => {
    const rowData = { ...appointmentDetails }
    rowData["documentCompleteStatus"] = type
    delete rowData["patientName"]
    delete rowData["gender"]
    delete rowData["age"]
    delete rowData["primaryPhoneNumber"]
    delete rowData["email"]
    delete rowData["isVIP"]
    delete rowData["allottedBed"]
    delete rowData["invoiceId"]
    delete rowData["isEditable"]
    delete rowData["dob"]
    delete rowData["bedIsVacant"]
    delete rowData["bedMadeVacantAt"]
    delete rowData["medicalRecordsId"]
    delete rowData["mocAppointmentId"]
    delete rowData["serviceName"]
    delete rowData["finalInvoiceAmount"]

    updateAppointment(rowData)
      .then((res: any) => {
        setAppointmentDetails({ ...res })
        if (type === "APPROVED") {
          setIsApproved(true)
        } else {
          setIsRejected(true)
        }
      })
      .catch((err: any) => console.log("Update Failed"))
  }

  const handleSend = async () => {
    // setIsLoading(true)
    const foundObj: any = completedForms?.find((ele: any) => ele.formTemplateName === completedFormSelected?.label)
    const consentId = foundObj?.id
    try {
      const response = await generateClinicalSummary(appointmentId, false, false, true)
      const { url } = response
      if (url) {
        const body = {
          clinicalSummaryUrl: url,
          centerId: appointmentDetails?.centerId
        }
        sendClinicalPdfData(body, consentId)
          .then((res: any) => {
            setIsLoading(false)
            setIsSuccess({
              message: completedFormSelected?.label === "Thank you Note" ? "Thank You Note Sent Successfully" : completedFormSelected?.label === "Referral Note" ? "Clinical Summary Sent Successfully" : ""
            })
            setCompletedFormSelected("")
            setComletedConsentJSON({})
            setComletedConsentPrintJSON({})
          })
          .catch((err: any) => {
            setIsLoading(false)
            console.log(err?.message)
            setIsError(true)
          })
      } else {
        setIsError(true)
      }
    }
    catch {
      setIsError(true)
    }
  }

  const getPrintJson = (tempJson: any) => {
    let printJSON: any = {}
    if (Object.keys(tempJson)?.length > 0) {
      Object.keys(tempJson)?.forEach((e: any) => {
        if (e !== "pages") {
          printJSON[e] = tempJson[e]
        } else {
          let elements: any = []
          printJSON["pages"] = []
          if (tempJson?.pages?.length > 0) {
            tempJson?.pages?.forEach((p: any) => elements = [...elements, ...p?.elements])
            if (Object.keys(tempJson?.pages[0])?.length > 0) {
              printJSON["pages"][0] = {}
              if (Object.keys(tempJson?.pages[0])?.includes("name")) {
                printJSON["pages"][0]["name"] = tempJson?.pages[0]["name"]
              }
              if (Object.keys(tempJson?.pages[0])?.includes("title")) {
                printJSON["pages"][0]["title"] = tempJson?.pages[0]["title"]
              }
              if (Object.keys(tempJson?.pages[0])?.includes("readOnly")) {
                printJSON["pages"][0]["readOnly"] = tempJson?.pages[0]["readOnly"]
              }
            }
            printJSON["pages"][0]["elements"] = elements
          }
        }
      })
    }
    return printJSON
  }

  function renderTabPanelOne() {
    return (
      <>
        {
          isLoading && (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9999,
              }}
            >
              <div
                style={{ width: "3rem", height: "3rem" }}
                className="spinner-border text-primary"
              ></div>
            </div>
          )
        }
        <Row
          className="heading-test"
          style={{
            paddingLeft: "25px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Forms

        </Row>
        <div className="select-forms">
          <Select
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: "1px solid #ccd0e7",
                borderRadius: "10px"
              })
            }}
            options={formOptions}
            defaultValue={formSelected}
            onChange={(option: any) => {
              setFormSelected(option)
              // setFormNumber() set formNumber to state
            }}
          />
        </div>
        <div>
          <label style={{ marginTop: "20px", marginLeft: "25px", marginBottom: "0px" }} htmlFor="" className="label">
            <b>
              {formSelected?.formNumber}
            </b>
          </label>
        </div>
        <div style={{ width: "100%" }}>
          {
            consentJSON && (<div className="forms-content">
              <SurveyComponent
                css={defaultSurveyConfig.defaultSurveyCSS}
                data={surveyData}
                json={consentJSON}
                onComplete={(survey: any) => {
                  /** Save to a database */
                  /** Add to a spreadsheet, etc.... */
                  handleFormComplete(survey?.data, "form")
                }}
                hideDot={true}
              // updateSelectedConsultant={upadateSelectedReferalConsultant}
              />
            </div>

            )
          }
        </div>
      </>
    )
  }

  function renderTabPanelTwo() {
    return (
      <>
        <Row
          className="heading-test"
          style={{
            paddingLeft: "25px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Saved Forms

        </Row>
        <Select
          styles={{
            control: (provided, state) => ({
              ...provided,
              border: "1px solid #ccd0e7",
              borderRadius: "10px"
            })
          }}
          options={savedFormOptions}
          defaultValue={savedFormSelected}
          onChange={(option: any) => {
            setSavedFormSelected(option)
          }}
        />
        <Box sx={{ width: "100%", marginTop: "20px" }}>
          <div style={{ marginLeft: "20px" }}>
            <label htmlFor="" className="label">
              <b>
                {formNumber}
              </b>
            </label>
          </div>
          {
            savedConsentJSON && (
              <SurveyComponent
                css={defaultSurveyConfig.defaultSurveyCSS}
                data={surveyData}
                json={savedConsentJSON}
                onComplete={(survey: any) => {
                  /** Save to a database */
                  /** Add to a spreadsheet, etc.... */
                  handleFormComplete(survey?.data, "saved")
                }}
                hideDot={true}
              />
            )
          }
        </Box>
      </>
    )
  }

  function renderTabPanelThree() {
    return (
      <>
        <Row
          className="heading-test"
          style={{
            paddingLeft: "25px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Completed Forms
        </Row>
        {
          userRole !== MocUserRole.MRD && (
            <Select
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  border: "1px solid #ccd0e7",
                  borderRadius: "10px"
                })
              }}
              options={completedFormOptions}
              defaultValue={completedFormSelected}
              onChange={(option: any) => {
                setCompletedFormSelected(option)
              }}
            />
          )
        }
        {
          userRole === MocUserRole.MRD && (
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <div className="flowsheet-content">
                <table className="table-inner">
                  <div className="rmo-table">
                    <>
                      <div className="rmo-label">
                        <tr className="rmoLabels">
                          <th className="center-aligned-labels">Form</th>
                          <th className="center-aligned-labels">MRD Mandated</th>
                          <th className="center-aligned-labels"> Verify</th>
                        </tr>
                      </div>

                      {completedForms?.map((data: any, index: any) => (
                        <tr className="rmoLabels">
                          <td
                            onClick={() => {
                              const temp = { label: data?.formTemplateName, value: data?.formTemplateId }
                              setCompletedFormSelected(temp)
                            }}
                          >
                            <span className="formTemplateName">{data?.formTemplateName}</span>
                          </td>
                          <td className="center-aligned-labels">
                            <input
                              className="verify-checkbox"
                              type="checkbox"
                              checked={checklistItems.includes(data?.formTemplateName) ? true : false}
                              disabled={checklistItems.includes(data?.formTemplateName) ? false : true}
                            />
                          </td>
                          <td className="center-aligned-labels">
                            <input
                              className="verify-checkbox"
                              type="checkbox"
                              checked={data?.verified}
                              onChange={() => {
                                const temp: any = [...completedForms]
                                temp[index]["verified"] = !temp[index]["verified"]
                                setCompletedForms(temp)
                              }}
                            />
                          </td>
                        </tr>
                      )
                      )}
                    </>
                  </div>
                </table>
              </div>
            </Box>
          )
        }

        <Box sx={{ width: "100%", marginTop: "20px" }}>
          {
            comletedConsentJSON && (
              <>
                <div
                  className="print-button cursor-pointer"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Print
                    componentRef={componentRef}
                  />
                </div>
                <div style={{ marginLeft: "20px" }}>
                  <label htmlFor="" className="label">
                    <b>
                      {formNumber}
                    </b>
                  </label>
                </div>
                <SurveyComponent
                  css={defaultSurveyConfig.defaultSurveyCSS}
                  data={surveyData}
                  json={comletedConsentJSON}
                  onComplete={(survey: any) => {
                    /** Save to a database */
                    /** Add to a spreadsheet, etc.... */
                    handleFormComplete(survey?.data, "completed")
                  }}
                  hideDot={true}
                />
                <div
                  className="print-component"
                  ref={componentRef}
                >
                  <label htmlFor="" className="label">
                    <b>
                      {completedFormSelected?.formNumber}
                    </b>
                  </label>
                  <PatientDetailsPrintHeader
                    patientData={{ patientInfo: patientInfo, vitalsData: null }}
                    smartSummaryData={smartSummaryData}
                    appointmentDate={appointmentDetails?.scheduleDate}
                  />
                  <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <label htmlFor="" className="label">
                      <b>
                        {formNumber}
                      </b>
                    </label>
                  </div>
                  <CommonPrintComponent
                    data={surveyData}
                    json={JSON.parse(JSON.stringify(comletedConsentPrintJSON))}
                    pageName="Forms"
                    hideDot={true}
                  />
                </div>
              </>
            )
          }
        </Box >
        {
          userRole === MocUserRole.MRD && (
            <Box sx={{ width: "100%", marginTop: "20px", display: "flex", justifyContent: "flex-end", flexDirection: "row" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row" }}>
                <div style={{ marginRight: "10px" }}>
                  <Button text="Approve" onClick={() => handleCompletenessChange(true)} id="approve" disabled={appointmentDetails?.documentCompleteStatus !== "PENDING" || userRole === MocUserRole.MRD && pathName === "/patientList"}></Button>
                </div>
                <div>
                  <Button text="Reject" onClick={() => handleCompletenessChange(false)} id="reject" disabled={appointmentDetails?.documentCompleteStatus !== "PENDING" || userRole === MocUserRole.MRD && pathName === "/patientList"}></Button>
                </div>
              </div>
            </Box>
          )
        }
        {
          isLoading && (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 9999,
              }}
            >
              <div
                style={{ width: "3rem", height: "3rem" }}
                className="spinner-border text-primary"
              ></div>
            </div>
          )
        }
        {
          (completedFormSelected?.label === "Thank you Note" || completedFormSelected?.label === "Referral Note") && (
            <Box sx={{ width: "100%", marginTop: "20px", display: "flex", justifyContent: "flex-end", flexDirection: "row" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row" }}>
                <div style={{ marginRight: "10px" }}>
                  <Button text="Send" onClick={() => handleSend()} id="approve" ></Button>
                </div>
              </div>
            </Box>
          )
        }
      </>
    )
  }

  function renderTabPanelFour() {
    return (
      <>
        <div className="pedigree-container">
          {
            mrdDocs?.length > 0 && (
              <div className="d-flex justify-content-end mt-3">
                <Button text="Download All" id="download-all" onClick={(e: any) => {
                  mrdDocs?.forEach((eachItm: any, i: number) => {
                    setTimeout(function (path) {
                      window.location = path?.blobUrl;
                    }, 200 + i * 200, eachItm);
                    if (i === 0) {
                      window.location = eachItm?.blobUrl;
                    }
                  })
                }} />
              </div>
            )
          }

          <div className="pedigree-docs-container">
            {mrdDocs?.length > 0 &&
              mrdDocs?.map((ele: any) => {
                return (
                  <div className="file-list">
                    <span>
                      <FontAwesomeIcon
                        className="doc-icon"
                        size="4x"
                        icon={faFileAlt}
                      />
                    </span>

                    <div className="file-name">{ele?.name}</div>

                    <a
                      // href={ele?.blobUrl}
                      // download={ele?.blobUrl}
                      onClick={() => fileUtils.downloadFile(ele)}
                    >
                      <FontAwesomeIcon
                        className="download-icon"
                        icon={faArrowDown}
                      />
                    </a>
                  </div>
                )
              })}
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="document-rmo-wrapper">
      {
        isApproved ? (
          <Toast
            textMessage="Approved successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => {
              setIsApproved(false)
              setShow(false)
            }}
          ></Toast>
        ) : isRejected ? (
          <Toast
            textMessage="Rejected successfully"
            type="success"
            onCloseText={"Close"}
            onClose={() => {
              setIsRejected(false)
              setShow(false)
            }}
          ></Toast>
        ) : isAllVerified ? (
          <Toast
            textMessage="Please verify all forms"
            type="error"
            onCloseText={"Close"}
            onClose={() => {
              setIsAllVerified(false)
            }}
          ></Toast>
        ) : ("")
      }
      <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col className="basic-patient-details">
                {PermissionUtils.displayPatientName(
                  userRole,
                  patientInfo,
                  false,
                  null,
                  "-"
                )}
                {patientInfo?.mocId}-{patientInfo?.gender}-{calculateAge(patientInfo?.dob)}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {displayToast &&
            <div>
              <Toast
                textMessage={displayToast.text}
                type="error"
                onCloseText={"Close"}
                onClose={() => {
                  setShow(false)
                  setDisplayToast(null)
                }}
              ></Toast>
            </div>
          }
          {
            saved ? (
              <div>
                <Toast
                  textMessage="Saved successfully"
                  type="success"
                  onCloseText={"Close"}
                  onClose={() => {
                    setSaved(false)
                    setShow(true)
                  }}
                ></Toast>
              </div>
            ) : isError ? (
              <Toast
                textMessage={"Something went wrong, please try again!!!"}
                onCloseText={"Close"}
                onClose={() => {
                  setIsError(false)
                }}
                type="error"
              ></Toast>
            ) : isSuccess ? (
              <Toast
                textMessage={isSuccess?.message}
                onCloseText={"Close"}
                onClose={() => {
                  setIsSuccess(false)
                }}
                type="success"
              ></Toast>
            ) : (
              <>
                <Row className="heading-test" style={{ paddingLeft: "25px" }}>
                  Forms
                </Row>
                <div >
                  <div>
                    <Tabs
                      TabIndicatorProps={{
                        sx: {
                          bgcolor: "blue",
                          height: "2px",
                          color: "blue",
                        },
                      }}
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        sx={{
                          textTransform: "none",
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                        label="Forms"
                        disabled={userRole === MocUserRole?.MRD && pathName === "/patientList" ? true : false}
                        {...a11yProps(0)}
                      />
                      <Tab
                        sx={{
                          textTransform: "none",
                          fontSize: "20px",
                          fontWeight: "700",
                        }}
                        label="Saved Forms"
                        disabled={userRole === MocUserRole?.MRD && pathName === "/patientList" ? true : false}
                        {...a11yProps(1)}
                      />

                      <Tab
                        sx={{
                          textTransform: "none",
                          fontSize: "20px",
                          fontWeight: "700",
                          borderRadius: "0px",
                        }}
                        label="Completed Forms"
                        {...a11yProps(1)}
                      />

                      {
                        userRole === MocUserRole?.MRD && (
                          <Tab
                            sx={{
                              textTransform: "none",
                              fontSize: "20px",
                              fontWeight: "700",
                              borderRadius: "0px",
                            }}
                            label={userRole === MocUserRole?.MRD && pathName === "/patientList" ? "Documents" : "My Forms"}
                            {...a11yProps(1)}
                          />
                        )
                      }

                    </Tabs>
                  </div>
                  <TabPanel value={value} index={0}>
                    {renderTabPanelOne()}
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    {renderTabPanelTwo()}
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    {renderTabPanelThree()}
                  </TabPanel>
                  <TabPanel value={value} index={3}>
                    {renderTabPanelFour()}
                  </TabPanel>
                </div>
              </>
            )
          }
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal >
    </div >
  )
}
export default Forms
